import React from 'react';
import { QueryHookOptions } from '@apollo/client';
import { OperationData, OperationVariables, gql } from '@ts-gql/tag';
import { useQuery } from '@ts-gql/apollo';

export const GET_CLIENT_LITE_QUERY = gql`
  query GetClientLite($cloudId: String!) {
    getClient(cloudId: $cloudId) {
      cloudId
      name
    }
  }
` as import('../../__generated__/ts-gql/GetClientLite').type;

export type GetClientLiteQueryVariables = OperationVariables<
  typeof GET_CLIENT_LITE_QUERY
>;
export type GetClientLiteQueryResult = OperationData<
  typeof GET_CLIENT_LITE_QUERY
>;

export type GetClientLiteResult = GetClientLiteQueryResult['getClient'];

export const useGetClientLite = (
  options: QueryHookOptions<
    GetClientLiteQueryResult,
    GetClientLiteQueryVariables
  >
) => {
  const variables = options.variables as GetClientLiteQueryVariables;

  const res = useQuery<typeof GET_CLIENT_LITE_QUERY>(GET_CLIENT_LITE_QUERY, {
    context: { service: 'clients' },
    variables,
    ...options,
  });

  const { data } = res;

  return React.useMemo(() => {
    return { ...res, data: data ? processData(data) : null };
  }, [res, data]);
};

export function processData(data: GetClientLiteQueryResult) {
  const client = data.getClient;
  const result: GetClientLiteQueryResult['getClient'] | null = client;
  return result;
}
